import React, { useMemo, useState } from "react";
import InnerHeader from "../../components/InnerHeader";
import BottomNav from "../../components/BottomNav/BottomNav";

const DEFAULT_DAYS = [
  { day: 1, icon: "🪙", claimed: true },
  { day: 2, icon: "🪙🪙", claimed: true },
  { day: 3, icon: "💰", claimed: true },
  { day: 4, icon: "🪙", claimed: false },
  { day: 5, icon: "🪙", claimed: false },
  { day: 6, icon: "🪙", claimed: false },
  { day: 7, icon: "🏆", claimed: false, wide: true },
];

export default function SignIn({
  title = "Daily Turnover Bonus",
  days = DEFAULT_DAYS,
  bonusAmount = 0,
  submittedTurnover = 0,
  bonusTurnoverTarget = 0,
  onConfirm,
}) {
  const [selectedDay, setSelectedDay] = useState(
    days.find((item) => !item.claimed)?.day || 1
  );

  const selectedInfo = useMemo(
    () => days.find((item) => item.day === selectedDay),
    [days, selectedDay]
  );

  const handleConfirm = () => {
    if (onConfirm) onConfirm(selectedInfo);
  };

  return (
    <>
    <InnerHeader title="Daily Login Bonus" />
  
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>{title}</h1>

        <div style={styles.dayGrid}>
          {days.map((item) => {
            const active = item.day === selectedDay;
            const claimed = item.claimed;

            return (
              <button
                key={item.day}
                type="button"
                onClick={() => setSelectedDay(item.day)}
                style={{
                  ...styles.dayCard,
                  ...(item.wide ? styles.dayCardWide : {}),
                  background: claimed || active ? "#4d36e8" : "#f3f3f3",
                  color: claimed || active ? "#ffffff" : "#171717",
                  boxShadow: active
                    ? "0 0 0 2px rgba(255,255,255,0.18) inset"
                    : "none",
                }}
              >
                <span style={styles.dayText}>DAY {item.day}</span>
                <span style={styles.dayIcon}>{item.icon}</span>
              </button>
            );
          })}
        </div>

        <div style={styles.claimRow}>
          <div style={styles.claimText}>Claim your bonus</div>

          <button type="button" onClick={handleConfirm} style={styles.confirmBtn}>
            Confirm
          </button>
        </div>

        <div style={styles.line} />

        <div style={styles.infoRow}>
          <span>Your Bonus Amount :</span>
          <strong style={styles.value}>{Number(bonusAmount).toFixed(2)}</strong>
        </div>

        <div style={styles.line} />

        <div style={styles.infoRowBlock}>
          <span>Turnover Target Must Be Reach Before Withdrawal Can Be</span>
          <strong style={styles.value}>{Number(submittedTurnover).toFixed(2)}</strong>
        </div>
        <div style={styles.infoRowBlock}>
          <span>Submitted :</span>
        </div>

        <div style={styles.line} />

        <div style={styles.infoRow}>
          <span>Bonus Turnover Target :</span>
          <strong style={styles.value}>
            {Number(bonusTurnoverTarget).toFixed(2)}
          </strong>
        </div>

        <div style={styles.line} />

        <div style={styles.noteTitle}>Sign-In Bonus Has Been Claimed :</div>

        <ol style={styles.noteList}>
          <li>Only 100BDT Turnover Needed To Claim The Bonus!</li>
          <li>It Will Be Recalculated If You Break Off One Day.</li>
          <li>Withdrawal Requirement: 10X Turnover</li>
        </ol>
      </div>
    </div>
    <BottomNav />
    </>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    width: "100%",
    background: "#040525",
    color: "#ffffff",
    fontFamily: "Arial, Helvetica, sans-serif",
    padding: "22px 20px 40px",
    boxSizing: "border-box",
  },

  container: {
    width: "100%",
    maxWidth: 560,
    margin: "0 auto",
  },

  title: {
    margin: "10px 0 34px",
    textAlign: "center",
    fontSize: 16,
    fontWeight: 700,
    color: "#f2f2f2",
  },

  dayGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: 12,
    marginBottom: 34,
  },

  dayCard: {
    border: "none",
    borderRadius: 14,
    height: 60,
    padding: "14px 10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-between",
    cursor: "pointer",
    fontSize: 16,
  },

  dayCardWide: {
    gridColumn: "span 2",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "14px 18px",
  },

  dayText: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.2,
  },

  dayIcon: {
    fontSize: 15,
    lineHeight: 1,
    alignSelf: "flex-end",
  },

  claimRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    marginBottom: 8,
  },

  claimText: {
    fontSize: 14,
    color: "#f2f2f2",
  },

  confirmBtn: {
    border: "none",
    borderRadius: "18px 0 18px 0",
    background: "linear-gradient(180deg, #f60c76, #9b19c8)",
    color: "#ffffff",
    fontSize: 15,
    fontWeight: 700,
    padding: "10px 22px",
    minWidth: 100,
    cursor: "pointer",
  },

  line: {
    height: 1,
    background: "rgba(255,255,255,0.75)",
    margin: "10px 0",
  },

  infoRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    fontSize: 13,
    lineHeight: 1.5,
  },

  infoRowBlock: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 12,
    fontSize: 13,
    lineHeight: 1.5,
  },

  value: {
    color: "#ffcf38",
    fontSize: 13,
    fontWeight: 700,
    flexShrink: 0,
  },

  noteTitle: {
    marginTop: 8,
    fontSize: 13,
    fontWeight: 700,
  },

  noteList: {
    margin: "12px 0 0 18px",
    paddingLeft: 16,
    color: "#f2f2f2",
    fontSize: 13,
    lineHeight: 1.75,
  },
};